export const invoicesDefaultTextHeaders = ['currency', 'customerId', 'tags', 'flag'];
export const customersDefaultTextHeaders = ['contactName', 'phone', 'tags', 'flag'];
